<template>
  <div class="h-grid h-grid--justify-content-center">
    <div class="h-grid__col h-grid__col--sm-10 h-grid__col--md-8">
      <hr />

      <div v-if="showErrors" class="m-form-error">
        <span class="m-form-error__item m-form-error__item--title">{{ $t('gathering-form-validation-error') }}</span>
        <span class="m-form-error__item" v-for="error in errors" :key="error">
          <span class="m-form-error__icon" />
          {{ error }}
        </span>
      </div>

      <div class="m-form-actions">

        <div class="m-form-actions__group m-form-actions__group--align-right">
          <span v-if="buttonIsSaveAndContinue" class="m-form-actions__item m-form-actions__item--inside-group m-form-actions__item--align-right">
            <button class="a-btn-primary" type="button" @click="saveAndContinue">
              {{ $t('button-save-and-continue-gathering') }}
            </button>
          </span>

          <span v-if="buttonIsSaveAndQuit" class="m-form-actions__item m-form-actions__item--inside-group m-form-actions__item--align-right">
            <button class="a-btn-primary" type="button" @click="saveAndQuit">
              {{ $t('button-save-and-quit-gathering') }}
            </button>
          </span>

          <span v-if="buttonIsSubmit" class="m-form-actions__item m-form-actions__item--inside-group m-form-actions__item--align-right">
            <button class="a-btn-primary" type="button" @click="submitGathering">
              {{ $t('button-submit-gathering') }}
            </button>
          </span>

          <a class="m-form-actions__item m-form-actions__item--inside-group m-form-actions__item--align-right" href="javascript:void();" @click="previewGathering">{{ $t('button-preview-gathering') }}</a>
          <a class="m-form-actions__item m-form-actions__item--inside-group m-form-actions__item--align-right" href="javascript:void();" v-if="!buttonIsSaveAndQuit" @click="saveAndQuit">{{ $t('button-save-and-quit-gathering') }}</a>
        </div>

        <div class="m-form-actions__group m-form-actions__group--align-left">
          <a class="m-form-actions__item m-form-actions__item--previous" href="javascript:void();" @click="saveAndBack">{{ $t('edit-gathering-go-back-btn') }}</a>
        </div>

      </div>
    </div>  
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasClickedOnce: false
    }
  },
  props: {
    showSubmit: {
      type: Boolean,
      required: true
    },
    isSubmitted: {
      type: Boolean,
      required: true
    },
    isAuthorized: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: false,
      default: function() {
        return []
      }
    }
  },
  computed: {
    showErrors: function() {
      return this.errors.length > 0 && this.hasClickedOnce
    },
    buttonIsSubmit: function() {
      return !this.isAuthorized && !this.isSubmitted && this.showSubmit
    },
    buttonIsSaveAndQuit: function() {
      return this.isSubmitted && this.showSubmit
    },
    buttonIsSaveAndContinue: function() {
      return !this.showSubmit
    }
  },
  methods: {
    saveAndBack: function() {
      this.hasClickedOnce = true
      this.$emit('saveAndBack')
    },
    previewGathering: function() {
      this.hasClickedOnce = true
      this.$emit('previewGathering')
    },
    saveAndQuit: function() {
      this.hasClickedOnce = true
      this.$emit('saveAndQuit')
    },
    saveAndContinue: function() {
      this.hasClickedOnce = true
      this.$emit('saveAndContinue')
    },
    submitGathering: function() {
      this.hasClickedOnce = true
      this.$emit('submitGathering')
    }
  }
}
</script>

<style lang="scss">
.m-form-error {
  color: color('error');

  &__item {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    margin-bottom: $margin-base / 2;

    &--title {
      font-weight: bold;
    }
  }

  &__icon {
    background: url(~@/assets/bang.svg);
    border-radius: 50%;
    background-size: 20px 20px;
    width: 20px;
    height: 20px;
    margin-right: $margin-base / 2;
    flex-shrink: 0;
  }
}

</style>
